import {action, observable, runInAction} from "mobx";
import {
    createRequestFilters,
    ListProviderPatientsRequest, ProviderCollectionPayment,
    ProviderPatient, ProviderPatientStatement
} from "@enter/core";
import {IFeatures, IItemListing, IItemListingRequest} from "./root.store";
import {appendTo, parseItemListingRequest} from "./util";
import _ from "lodash";
import {PaymentGenerator} from "./payment.generator";
import {PatientGenerator} from "./patient.generator";
import {PaymentService} from "./payment.service";
import {PatientService} from "./patient.service";

export class PatientStore {
    @observable public patients: ProviderPatient[] = [];

    private features: IFeatures;
    private patientGenerator: PatientGenerator;
    private patientService: PatientService = new PatientService();

    constructor(features: IFeatures, patientGenerator: PatientGenerator) {
        this.features = features;
        this.patientGenerator = patientGenerator;
    }

    // @action
    // public async loadPatientListing(ilr: IItemListingRequest): Promise<IItemListing<ProviderPatient>> {
    //     const lpgr = ilr2lpgr(ilr);
    //     const listing = await (this.features.isDemo
    //         ? this.patientGenerator.loadPatientListing(lpgr)
    //         : this.patientService.fetchPatientListing(lpgr));
    //     if (!listing) {
    //         throw new Error(`No patients available`);
    //     }
    //     const { items } = listing;
    //     runInAction(() => {
    //         this.patients = appendTo<ProviderPatient>(this.patients, items);
    //     });
    //     return listing;
    // }


    @action
    public async loadPatientStatement(id: string): Promise<ProviderPatientStatement> {
        return this.patientService.fetchPatientStatement(id);
    }
}



// export const ilr2lpgr = (ilr: IItemListingRequest): ListProviderPatientsRequest => {
//     const base = parseItemListingRequest(ilr) as ListProviderPatientsRequest;
//     const filters = createRequestFilters(_.get(ilr, 'filters'), true);
//     return {
//         ...base,
//         ...filters,
//     };
// };